export const routes = {
  home: '/',
  projectSection: '/project/:projectId',
  netSuiteSynchronisationInformation: '/netsuite-synchronisation-information',
  documentSection: '/documents',
};
